import React from 'react';
import logo from '../assets/logo.jpg';
import factoryImage from '../assets/factory-image.jpg';

const ApplicationsSection = () => {
  const applications = [
    {
      title: "Factories",
      description: "30 to 100 kW system reduces diesel fuel consumption, enhances energy independence.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
    },
    {
      title: "Commercial Buildings",
      description: "10 to 30 kW systems can substatially reduces diesel fuel consumption.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
    {
      title: "Homes",
      description: "5kW system can immediately deliver benefits.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
  ];

  return (
    <section className="bg-white py-12 md:py-20" id="applications">
    <div className="max-w-7xl mx-auto px-4 md:px-6">
      {/* Change grid layout for different screen sizes */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        {/* Left Content - full width on tablet */}
        <div className="lg:col-span-4 space-y-6">
          <img src={logo} alt="Sun Energy Logo" className="h-16 md:h-20 w-auto mb-6" />
          
          <div className="space-y-6">
            <div className="space-y-2">
              <p className="text-orange-500 font-bold text-xl md:text-2xl">RELIABILITY</p>
              <p className="text-orange-500 font-bold text-xl md:text-2xl">ENVIRONMENTALLY FRIENDLY</p>
            </div>
  
            <h2 className="text-3xl md:text-4xl text-blue-900 font-bold">
              Applications<br />
              of Solar
            </h2>
  
            <h3 className="text-blue-900 font-bold">
              HOMES, BUSINESSES, FACTORIES
            </h3>
  
            <div className="space-y-4 md:max-w-2xl lg:max-w-none">
              <p className="text-gray-700">
                Solar panels powers homes with clean, renewable energy, reducing electricity bills.
              </p>
              <p className="text-gray-700">
                For businesses, factories and commercial spaces, solar energy lowers operational costs by reduces diesel fuel consumption and enhances energy independence.
              </p>
            </div>
          </div>
        </div>
  
        {/* Image and Right Panel - grid on tablet */}
        <div className="lg:col-span-8">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Center Image */}
            <div className="h-[300px] md:h-[400px]">
              <img
                src={factoryImage}
                alt="Solar Panel Manufacturing"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
  
            {/* Right Panel */}
            <div className="bg-blue-900 p-6 md:p-8 rounded-lg">
              <div className="space-y-8">
                {applications.map((app, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="bg-orange-500 p-3 rounded-xl shrink-0">
                      <div className="text-white">
                        {app.icon}
                      </div>
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-lg mb-2">
                        {app.title}
                      </h4>
                      <p className="text-gray-200 text-base">
                        {app.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default ApplicationsSection;